module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "printerModal"
    }
  }, [_c('row', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('column', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": _vm.title,
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Printer IP Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerIP),
      expression: "printerIP"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Printer IP Address"
    },
    domProps: {
      "value": (_vm.printerIP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.printerIP = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.$root.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Dealer")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dealerKey),
      expression: "dealerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dealerKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$root.dealers), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.$root.isCustomer) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Customer")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerKey),
      expression: "customerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.customerKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dealerCustomers), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Site")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteKey),
      expression: "siteKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.siteKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.customerSites), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "align": "center"
    }
  }, [_c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n                ")])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Save",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-3"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04785c04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddPrinter.vue
// module id = 663
// module chunks = 0